import loadAsync from "routing/loadAsync";
const DashboardsPage = loadAsync(() => import(
  /* webpackChunkname: "DashboardsPage" */
  "./DashboardsPage"
));
const NewSearchPage = loadAsync(() => import(
  /* webpackChunkName: "NewSearchPage" */
  "./NewSearchPage"
));
const StreamSearchPage = loadAsync(() => import(
  /* webpackChunkName: "StreamSearchPage" */
  "./StreamSearchPage"
));
const NewDashboardPage = loadAsync(() => import(
  /* webpackChunkName: "NewDashboardPage" */
  "./NewDashboardPage"
));
const ShowViewPage = loadAsync(() => import(
  /* webpackChunkName: "ShowViewPage" */
  "./ShowViewPage"
));
const EventReplaySearchPage = loadAsync(() => import(
  /* webpackChunkName: "ShowViewPage" */
  "./EventReplaySearchPage"
));
const EventDefinitionReplaySearchPage = loadAsync(
  () => import(
    /* webpackChunkName: "ShowViewPage" */
    "./EventDefinitionReplaySearchPage"
  )
);
const BulkEventReplayPage = loadAsync(
  () => import(
    /* webpackChunkName: "BulkEventReplayPage" */
    "./BulkEventReplayPage"
  )
);
export {
  DashboardsPage,
  NewSearchPage,
  ShowViewPage,
  StreamSearchPage,
  NewDashboardPage,
  EventReplaySearchPage,
  EventDefinitionReplaySearchPage,
  BulkEventReplayPage
};
